import { render } from "./setGoldFuelProviders.vue?vue&type=template&id=4aa9075a&scoped=true"
import script from "./setGoldFuelProviders.vue?vue&type=script&lang=js"
export * from "./setGoldFuelProviders.vue?vue&type=script&lang=js"

import "./setGoldFuelProviders.vue?vue&type=style&index=0&id=4aa9075a&lang=scss"
import "./setGoldFuelProviders.vue?vue&type=style&index=1&id=4aa9075a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aa9075a"]])

export default __exports__